/** @format */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationState, applicationReducer, ApplicationEffects } from './application';

export interface State {
	applicationReducer: ApplicationState;
}

export const reducers: any = { applicationReducer };
export const effects = ApplicationEffects;

export const getApplicationState = createFeatureSelector<ApplicationState>('applicationReducer');

export const getAllScheduledAssignments = createSelector(getApplicationState, (state: ApplicationState) => state.allScheduledActingAssignments);

export const getUserRelatedScheduledAssignments = createSelector(
	getApplicationState,
	(state: ApplicationState) => state.userScheduledActingAssignments
);

export const getCalendarEntries = createSelector(getApplicationState, (state: ApplicationState) => state.calendarEntries);

export const getProfile = createSelector(getApplicationState, (state: ApplicationState) => state.profile);

export const getUserAccount = createSelector(getApplicationState, (state: ApplicationState) => state.profile.user);

export const getManagedUsers = createSelector(getApplicationState, (state: ApplicationState) => state.profile.manage);

export const getTimekeeperManagedUsers = createSelector(getApplicationState, (state: ApplicationState) => state.profile.timekeeperManagedUsers);

export const getExceptionsList = createSelector(getApplicationState, (state: ApplicationState) => state.exceptionTypes);

export const getIsLoadingData = createSelector(getApplicationState, (state: ApplicationState) => state.isLoadingData);

export const getSelectedYear = createSelector(getApplicationState, (state: ApplicationState) => state.selectedYear);

export const getProfilePicture = createSelector(getApplicationState, (state: ApplicationState) => state.profilePicture);

export const getBankTypes = createSelector(getApplicationState, (state: ApplicationState) => state.bankTypes);

export const getTimeBanks = createSelector(getApplicationState, (state: ApplicationState) => state.timeBank);

export const getPayPeriods = createSelector(getApplicationState, (state: ApplicationState) => state.payPeriods);

export const getPayPeriodEntries = createSelector(getApplicationState, (state: ApplicationState) => state.payPeriodEntries);

export const getNotifications = createSelector(getApplicationState, (state: ApplicationState) => state.notifications);

export const getTimesheets = createSelector(getApplicationState, (state: ApplicationState) => state.timesheets);

export const getTimesheetHistory = createSelector(getApplicationState, (state: ApplicationState) => state.timesheetHistory);

export const getEmployeeTimesheets = createSelector(getApplicationState, (state: ApplicationState) => state.directEmployeeTimesheets);

export const getTimeEntries = createSelector(getApplicationState, (state: ApplicationState) => state.timeEntries);

export const getExceptionTypes = createSelector(getApplicationState, (state: ApplicationState) => state.exceptionTypes);

export const getTeamProfile = createSelector(getApplicationState, (state: ApplicationState) => state.teamProfile);

export const getDirectEmployeeTimesheets = createSelector(getApplicationState, (state: ApplicationState) => state.directEmployeeTimesheets);

export const getApprovedTimesheets = createSelector(getApplicationState, (state: ApplicationState) => state.approvedTimesheets);

export const getAllUserTimesheets = createSelector(getApplicationState, (state: ApplicationState) => state.allUserTimesheets);

export const getUserDelegationEntries = createSelector(getApplicationState, (state: ApplicationState) => state.userDelegationEntries);

export const getUserImages = createSelector(getApplicationState, (state: ApplicationState) => state.userImages);

export const getSystemUser = createSelector(getApplicationState, (state: ApplicationState) => state.systemUser);

export const getAllUsers = createSelector(getApplicationState, (state: ApplicationState) => state.allUsers);
